// Lightweight analytics data-layer. Marketing tags load ONLY when their
// environment IDs are present. No IDs are ever hard-coded.
import { analytics } from "@/content/site";

let initialised = false;

export function initAnalytics() {
  if (initialised || typeof window === "undefined") return;
  initialised = true;
  window.dataLayer = window.dataLayer || [];

  if (analytics.gtmId) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${analytics.gtmId}`;
    document.head.appendChild(s);
  }
  if (analytics.ga4Id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${analytics.ga4Id}`;
    document.head.appendChild(s);
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", analytics.ga4Id);
  }
  if (analytics.metaPixelId) {
    // Meta Pixel loader only runs when an ID is provided.
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', analytics.metaPixelId);
    window.fbq('track', 'PageView');
    /* eslint-enable */
  }
}

// Consistent event tracking through a single data layer.
export function track(event, payload = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
  if (window.gtag && analytics.ga4Id) window.gtag("event", event, payload);
}
